import { createAtom } from '../utils';

// for syncing threshold between performance charts and first run live experience dialog
export const thresholdForPredictAtom = createAtom<number | undefined>(
  'thresholdForPredict',
  undefined,
);
